var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isActionAdd)?_c('div',{staticClass:"col-4 used-on-section"},[_c('p',{staticClass:"uo-legend"},[_vm._v("Used On")]),_vm._v(" "),_c('div',{staticClass:"uo-container",domProps:{"innerHTML":_vm._s(_vm.getUsedOnPages)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }